module.exports = __webpack_public_path__ + "static/media/gh.733b0135.svg";